var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.99925C5.01592 8.01092 4.04202 7.80867 3.1524 7.40791C2.46282 7.08751 1.84359 6.64504 1.3278 6.10411C0.781459 5.54483 0.35128 4.8921 0.06 4.18041L0 3.99986L0.063 3.81932C0.354489 3.10825 0.783741 2.45568 1.3284 1.89561C1.844 1.35473 2.46302 0.912258 3.1524 0.591814C4.04203 0.191069 5.01593 -0.0111729 6 0.000476139C6.98407 -0.0111528 7.95797 0.191088 8.8476 0.591814C9.5372 0.912184 10.1564 1.35466 10.6722 1.89561C11.2196 2.45413 11.6499 3.10706 11.94 3.81932L12 3.99986L11.937 4.18041C10.9957 6.51364 8.62452 8.03887 6 7.99925ZM6 1.14316C3.95752 1.08221 2.08285 2.21448 1.2702 3.99986C2.08272 5.78536 3.95748 6.91767 6 6.85656C8.04243 6.91735 9.91702 5.78514 10.7298 3.99986C9.91821 2.21361 8.04285 1.08093 6 1.14316ZM6 5.71388C5.1344 5.71934 4.38562 5.14103 4.21258 4.3334C4.03954 3.52576 4.49056 2.71436 5.28923 2.39649C6.0879 2.07861 7.01114 2.34305 7.49313 3.02773C7.97511 3.71241 7.88122 4.6261 7.269 5.20882C6.93379 5.53177 6.47685 5.71364 6 5.71388Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordShow);
export default __webpack_public_path__ + "static/media/password_show.9849fe8cc02ca50e395fde1f195afe32.svg";
export { ForwardRef as ReactComponent };